import { NgModule, ErrorHandler, Provider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ErrorHandlerMiddleware } from './error-handler.middleware';
import { UrlInterceptor } from './url.interceptor';
import { SessionInterceptor } from './session.interceptor';
import { UserDefinedI18nInterceptor } from './user-defined-i18n/user-defined-i18n.interceptor';

// Notice: providing order is important!
const interceptors: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useClass: UrlInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: UserDefinedI18nInterceptor,
    multi: true,
  },
];

@NgModule({
  imports: [CommonModule],
  providers: [
    /**
     * Providing all necessary service for error handling on the XVI_UI side.
     * All working around all errors should be implemented within the borders of this module.
     */
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerMiddleware,
    },
    ...interceptors,
  ],
})
export class MiddlewaresModule {
  public constructor() {}
}
